import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';


@inject(HttpClient)
export class PaymentWhiteLabelAdminAPI {

    constructor(http) {
        this.http = http;
    }

    getPublicApiKey(token, successCallback, errorCallback, wl_id) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });

        let queryString = '';

        if(wl_id) {
            queryString += `?wl_id=${wl_id}`;
        }

        this.http.get('api/wladmin/payment/getPublicApiKey'+queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("key"))
                        successCallback(json.key);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getList(user_id, page, limit, sortBy, sortDir, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });

        var queryString = "?page=" + page;
        queryString += "&limit=" + limit;
        queryString += "&sortBy=" + sortBy;
        queryString += "&sortDir=" + sortDir;

        this.http.get('api/wladmin/payment/getList' + (user_id == null ? "" : "/" + user_id) + queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("payments"))
                        successCallback(json.payments);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getInvoiceList(page, limit, sortBy, sortDir, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });

        var queryString = "?";

        if(page && limit) {
            queryString += "page=" + page;
            queryString += "&limit=" + limit;
            queryString += "&sortBy=" + sortBy;
            queryString += "&sortDir=" + sortDir;
        } else {
            queryString += "sortBy=" + sortBy;
            queryString += "&sortDir=" + sortDir;
        }

        this.http.get('api/wladmin/payment/getInvoiceList' + queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("invoices"))
                        successCallback(json.invoices);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    processUnpaidInvoicePayments(token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader('Authorization', token);
        });

     
        this.http.post('api/wladmin/payment/processUnpaidInvoicePayments')
            .then(data => {
                if (data.isSuccess) {
                    let json = JSON.parse(data.response);

                    if (json.hasOwnProperty('success')) {
                        successCallback();
                    }

                    if (json.hasOwnProperty('error')) {
                        errorCallback(json.error);
                    }
                } else {
                    errorCallback(data.statusText);
                }
            });
    }

    getPackageList(token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader('Authorization', token);
        });

        this.http.get('api/wladmin/payment/pricing')
            .then(data => {
                if (data.isSuccess) {
                    let json = JSON.parse(data.response);

                    if (json.hasOwnProperty('packages')) {
                        successCallback(json.packages);
                    }

                    if (json.hasOwnProperty('error')) {
                        errorCallback(json.error);
                    }
                } else {
                    errorCallback(data.statusText);
                }
            });
    }

    savePackageList(data, token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader('Authorization', token);
        });

        this.http.post('api/wladmin/payment/pricing', data)
            .then(data => {
                if (data.isSuccess) {
                    let json = JSON.parse(data.response);

                    if (json.hasOwnProperty('packages')) {
                        successCallback(json.packages);
                    }

                    if (json.hasOwnProperty('error')) {
                        errorCallback(json.error);
                    }
                } else {
                    errorCallback(data.statusText);
                }
            });
    }

    getWLRPriceStructure(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader('Authorization', token);
        });

        this.http.get('api/wlusers/getWLRPriceStructure/' + data)
            .then(data => {
                if (data.isSuccess) {
                    let json = JSON.parse(data.response);

                        successCallback(json);

                    if (json.hasOwnProperty('error')) {
                        errorCallback(json.error);
                    }
                } else {
                    errorCallback(data.statusText);
                }
            });
    }


    setWLRPriceStructure(data, token, successCallback, errorCallback) {


        // var formData = new FormData();
        // formData.append('wl_id', data);
        // let wl_id = {
        //     'wl_id' : data
        // }
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader('Authorization', token);
        });

        this.http.post('api/wlusers/setWLRPriceStructure' , data)
            .then(data => {
                if (data.isSuccess) {
                    let json = JSON.parse(data.response);

                        successCallback(json);

                    if (json.hasOwnProperty('error')) {
                        errorCallback(json.error);
                    }
                } else {
                    errorCallback(data.statusText);
                }
            });
    }


}